'use client';

import { useEffect } from 'react';

/**
 * Hotjar tracking script component
 * Loads the Hotjar tracking code in the head section
 * Site ID: 3605179
 */
const HotjarScript = () => {
  const hotjarSiteId = process.env.NEXT_PUBLIC_HOTJAR_ID;

  useEffect(() => {
    // Check if Hotjar is already loaded
    if (typeof window !== 'undefined' && !(window as any).hj && hotjarSiteId) {
      // Hotjar Tracking Code - matches official implementation exactly
      (function (h: any, o: Document, t: string, j: string) {
        let a: Element | null;
        let r: HTMLScriptElement;
        h.hj =
          h.hj ||
          function (...args: any[]) {
            (h.hj.q = h.hj.q || []).push(args);
          };
        h._hjSettings = { hjid: parseInt(hotjarSiteId), hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = true;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        if (a) {
          a.appendChild(r);
        }
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
  }, [hotjarSiteId]);

  return null;
};

export default HotjarScript;
